<div class="hidden ml-3 order-wizard-debug-messages-container" [ngClass]="showDebug ? 'xl:block' : ''">
  <p-card class="fixed right-0" data-cy="order-wizard-debug-messages-container">
    <button
      pButton
      type="button"
      label="Hide"
      class="p-button-text p-button-sm flex-none"
      (click)="hideDebugContent()"
      data-cy="hide-debug-button"
    ></button>
    <div class="messages-inner-container">
      <p-messages
        key="orderWizardDebugMessages"
        [style]="{ 'white-space': 'pre-line' }"
        data-cy="order-wizard-debug-messages"
        styleClass="debug-messages"
      ></p-messages>
    </div>
  </p-card>
</div>
<button
  pButton
  type="button"
  label=""
  aria-label="Show debug info"
  icon="pi pi-info-circle"
  class="p-button-text p-button-sm flex-none fixed hidden text-grey-300"
  (click)="showDebugContent()"
  [ngClass]="!isProduction && !showDebug ? 'xl:block' : ''"
  data-cy="show-debug-button"
></button>
